"use client"

export function LandscapeBlocker() {
  return (
    <div className="landscape-blocker fixed inset-0 min-h-dvh min-w-dvw items-center justify-center overflow-hidden bg-[#06152d] bg-[url('/img/landscape-bg.webp')] bg-cover bg-center text-white z-50">
      <div className="panel absolute inset-x-0 bottom-0 h-36 bg-[radial-gradient(circle_at_20%_100%,#ff4b92_0,transparent_28%),radial-gradient(circle_at_80%_96%,#48d6ff_0,transparent_26%)] opacity-70" />
      <section className="relative z-10 w-full max-w-[365px] rounded-[2rem] border border-cyan-200/55 bg-cyan-900/45 px-[57px] py-[26px] md:px-[57px] md:py-[56px] shadow-2xl backdrop-blur-[5px] text-[20px] md:text-[24px] md:min-w-[460px] leading-[120%] text-center font-black">
        <div className="pb-[20px]">
          Переверните телефон в портретную ориентацию для продолжения игры
        </div>
        <img src="/img/landscape-icon.svg" className="inline" />
      </section>
    </div>
  )
}
